import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

const ehPermitidoAcesso = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const keycloak = inject(Keycloak);

  if (!authData.authenticated) {
    console.log('Não autenticado');
    await keycloak.login({
      redirectUri: window.location.origin + state.url,
    });
    return false;
  }

  try {
    await keycloak.updateToken(30);
    return true;
  } catch (error) {
    keycloak.login();
    return false;
  }
};

const ehPermitidoAcessoAssistente = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  if (!authData.authenticated) {
    return true;
  }

  try {
    await keycloak.updateToken(30);

    const resourceAccess = keycloak.tokenParsed?.resource_access || {};
    const possuiRecursoAssistente = Boolean(resourceAccess['api-assistente-digital']);

    if (!possuiRecursoAssistente) {
      return router.createUrlTree(['/access-denied']);
    }

    return true;
  } catch (error) {
    return router.createUrlTree(['/access-denied']);
  }
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(ehPermitidoAcesso);
export const canActivateAssistantResource = createAuthGuard<CanActivateFn>(
  ehPermitidoAcessoAssistente,
);
